import TagsMenuItem from '@/components/common/tags/tags-tmpl'
import UnsavedDataMixin from '@/components/mixins/unsaved-data-mixin'
import MediaMenu from '@/components/common/media-menu/media-menu-tmpl'
import ResolutionCalculator from '@/components/common/led-resolution-calculator/led-resolution-calculator-tmpl'
import Canvas from '@/components/pages/player/player-setup/player-data-canvas'
import _ from 'lodash'

const ResolutionTypes = {
  LED: 'led',
  VIDEOWALL: 'videowall'
}

export default {
  name: 'editPprojectTemplateMenu',
  inject: [
    '$currentUser',
    '$utils',
    '$api',
    '$apiError'
  ],
  components: { TagsMenuItem, MediaMenu, ResolutionCalculator },
  props: {
    playersProp: {
      type: Array,
      default () { return [] }
    },
    updateResolutionProp: {
      default () { return {} }
    },
    resolutionType: {
      type: String,
      default: ResolutionTypes.LED
    },

    showCancelBtn: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    playersProp: {
      handler (newVal) {
        const menuItems = this.$utils.clone(this.menuItems)
        const findIndex = menuItems.findIndex((item) => { return item.id === 'player' })
        menuItems[findIndex].values = newVal
        this.menuItems = menuItems
      },
      deep: true
    },
    updateResolutionProp (newVal) {
      const menuItemData = this.$utils.clone(this.menuItemData)
      menuItemData.resolution = {
        width: newVal.resolution.width,
        height: newVal.resolution.height
      }
      this.menuItemData = menuItemData
    }
  },
  mixins: [UnsavedDataMixin],
  computed: {
    isVideoWall () {
      return this.resolutionType === ResolutionTypes.VIDEOWALL
    }
  },
  data () {
    return {
      createNewConfig: true,
      error: '',
      selectedEditFrameTab: this.editTemplateFrameTabProp,
      menuItemData: {
        player: {},
        resolution: {
          height: 1080,
          width: 1080
        },
        pitch: 1,
        size: {
          height: 0,
          width: 0
        }
      },
      menuItems: [{
        id: 'resolution',
        name: this.$t('label.newResolution'),
        value: null,
        type: 'resolution'
      }],
      tagsSummaryForSuggestions: this.tagsSummaryForSuggestionsProp,
      showTagsMenuItem: this.$currentUser.hasGroupExtended(),
      createNewSetting: {
        tagsRequest: {
          status: null,
          responseData: null
        }
      },
      showCalculator: false,
      updateCalcResolution: {
        ref: null,
        width: 1080,
        height: 1080
      },
      canvasName: '',
      canvasInstance: new Canvas(this.$api),
      formErrors: {
        resolution: ''
      },
      createAllowed: false
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('led-resolution-menu-change', { action, payload: { data } })
      }
    },
    setDefaultData (params) {
      // Set Menu Item Data
      this.resetMenuItemData()
      this.calculateDimension({ templateSize: true }) // Update Template size value
    },
    calculateDimension (params) {
      if (params.playerResolution) {
        this.menuItemData.resolution = {
          width: this.menuItemData.size.width * this.menuItemData.pitch,
          height: this.menuItemData.size.height * this.menuItemData.pitch
        }
      }

      if (params.templateSize) {
        this.menuItemData.size = {
          width: Math.round(this.menuItemData.resolution.width / this.menuItemData.pitch),
          height: Math.round(this.menuItemData.resolution.height / this.menuItemData.pitch)
        }
      }
    },
    async handleMenuItemChange (item) {
      this.formErrors.resolution = ''

      // FIXME: refactor this to standard Element UI/Plus Form validation instead of manual validation here
      const newMenuItemData = this.menuItemData

      // normalize model values regardless current type
      const widthRaw = _.toString(newMenuItemData.resolution.width)
      const heightRaw = _.toString(newMenuItemData.resolution.height)

      // convert model values
      const width = Number.parseInt(widthRaw)
      const height = Number.parseInt(heightRaw)

      if (
        // validate for falsyness
        _.isEmpty(widthRaw) || _.isEmpty(heightRaw) ||
        // contains non-integer characters
        !widthRaw.match(/^[0-9]+$/g) || !heightRaw.match(/^[0-9]+$/g) ||
        // except NaN
        _.isNaN(width) || _.isNaN(height) ||
        // greater than 0
        width < 1 || height < 1
      ) {
        this.formErrors.resolution = this.$t('label.invalidResolution')
        return
      }

      // Filter values to make sure all are numbers
      newMenuItemData.resolution.width = width
      newMenuItemData.resolution.height = height

      this.menuItemData = newMenuItemData

      this.$nextTick(async _ => {
        if (item.id === 'resolution') {
          this.createAllowed = false

          await this.isCanvasPresentDebounced()
          this.calculateDimension({ templateSize: true }) // Update Template size value
        }

        this.updateCalcResolution = {
          ref: this.$utils.generateUniqueID(),
          width,
          height
        }

        this.emitEvent('CONFIG_CHANGE', this.menuItemData)
      })
    },
    async handleNewSetting () {
      // do not allow to create canvas if there's one with the same resolution
      // NOTE: validation would force to show "Canvas exists" error message
      if (await this.isCanvasPresent()) {
        return
      }

      if (this.formErrors.resolution) {
        return
      }

      if (ResolutionTypes.VIDEOWALL === this.resolutionType && !this.createAllowed) {
        return
      }

      let response, error

      this.createNewSetting = {
        tagsRequest: {
          status: null,
          response: null
        }
      }

      this.$utils.mainLoader(true)

      const commonNextAction = (response) => {
        if (this.createNewSetting.tagsRequest.status === 'done') {
          this.emitEvent('NEW_SETTING_CREATED', {
            tag: response.name,
            width: this.menuItemData.resolution.width,
            height: this.menuItemData.resolution.height,
            type: this.resolutionType
          })
        }
      }

      const { width, height } = this.menuItemData.resolution

      // due to asynchronisity, there's little chance of width or height to be not a number
      if (!_.isNumber(width) || !_.isNumber(height)) {
        console.log('Width or Heights are not a number')
        this.formErrors.resolution = this.$t('label.invalidResolution')
        this.$utils.mainLoader(false)
        return
      }

      // Create New Tag
      if (this.resolutionType === ResolutionTypes.LED) {
        response = await this.canvasInstance.createLED('', width, height)
      } else {
        response = await this.canvasInstance.createVideowall(this.canvasName, width, height, [])
      }

      if (response.error) {
        this.$apiError.handleAPIRequestError(error, { originalRequest: () => { this.handleNewSetting() }, showDialogNotification: true })
      }

      const createNewSetting = this.$utils.clone(this.createNewSetting)
      createNewSetting.tagsRequest = {
        status: 'done',
        responseData: response.ok
      }
      this.createNewSetting = createNewSetting
      commonNextAction(response.ok)
    },
    resetMenuItemData () {
      this.menuItemData = {
        player: {},
        resolution: {
          height: 1080,
          width: 1080
        },
        pitch: 1,
        size: {
          height: 0,
          width: 0
        }
      }
    },
    handleResolutionCalChange ($event) {
      if ($event.action === 'APPLY_NEW_CAL_RESOLUTION') {
        const menuItemData = this.$utils.clone(this.menuItemData)
        menuItemData.resolution = {
          width: $event.payload.data.resolution.width,
          height: $event.payload.data.resolution.height
        }

        this.menuItemData = menuItemData
      }
    },
    showResolutionCalc () {
      if (this.showCalculator) {
        this.showCalculator = false
      } else {
        this.showCalculator = true
      }

      this.emitEvent('SHOW_RESOLUTION_CALCULATOR', { isVisible: this.showCalculator })
    },
    async onInputCanvasName () {
      await this.isCanvasPresentDebounced()
    },
    async isCanvasPresent () {
      const { resolution } = this.menuItemData
      const { ok: existingCanvas } = await this.canvasInstance.findExistingCanvas(this.resolutionType, `${resolution.width} ${resolution.height}`)

      // check that either Videowall or LED types involved in check
      if (existingCanvas && [ResolutionTypes.VIDEOWALL, ResolutionTypes.LED].includes(this.resolutionType)) {
        this.formErrors.resolution = this.$t('label.canvasExistsError')
        this.createAllowed = false
        return true
      } else {
        this.createAllowed = true
        return false
      }
    },

    handleCloseForm () {
      this.$emit('cancel')
    }
  },
  mounted () {
    this.setDefaultData(this.ledData)
    this.isCanvasPresentDebounced = _.debounce(this.isCanvasPresent.bind(this), 1000)
  },
  beforeUnmount () {
    this.isCanvasPresentDebounced = null
  }
}
